<template>
  <div ref="name">
    <div class="content_box">
      <!-- 内容一 -->
      <el-row>
        <!-- <el-col :span="12" style="margin-right: 10px">
          <div class="grid-content bg-purple multiple">
            <div class="model_navigation">
              <img src="../../assets/images-img/months.png" alt />
              <span class="span1">包月总数:</span>
              <span class="span2">
                <sup>{{ list.total_month }}</sup>
              </span>
            </div>
            <div class="model_navigation">
              <img src="../../assets/images-img/normal.png" alt />
              <span class="span1">正常:</span>
              <span class="span2">
                <sup>{{ list.normal_count }}</sup>
              </span>
            </div>
            <div class="model_navigation">
              <img src="../../assets/images-img/ontrial.png" alt />
              <span class="span1">试用中:</span>
              <span class="span2">
                <sup>{{ list.try_count }}</sup>
              </span>
            </div>
            <div class="model_navigation">
              <img src="../../assets/images-img/expire.png" alt />
              <span class="span1">已到期:</span>
              <span class="span2">
                <sup>{{ list.overdue_count }}</sup>
              </span>
            </div>
          </div>
        </el-col> -->

        <el-col :span="12" :class="crityStyleEl_right_box ? 'el_right_box1' : 'el_right_box'">
          <div style="display:flex">
            <div class="grid-content bg-purple">
              <span class="status">网吧状态</span>
              <template>
                <el-select v-model="value" placeholder="全部" @change="selectState" style="width: 100px">
                  <el-option v-for="item in options" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
                <!-- <input v-model="searchName" v-if="crityStyleEl_right_box" /> -->
              </template>
            </div>

            <div class="each_txt">
              <span class="search_txt" style="padding-left: 20px">搜索</span>
              <div class="search_box">
                <el-input v-model="searchName" placeholder="请输入登录账号或名称" class="el_input_style"></el-input>
                <!-- <input  v-model="searchName"  placeholder="请输入要查询的网吧账号和名称" class="el_input_style" > -->
                <!-- <input v-model="searchName" v-if="crityStyleEl_right_box" /> -->
                <el-button type="goon" icon="el-icon-search" style="margin-left: 20px"
                  @click="searchQuery()"></el-button>
                <!-- <div class="search" @click="searchQuery()">
                <img src="../../assets/images-img/echar.png" alt />
              </div> -->
              </div>
            </div>
          </div>
          <div v-if="bardeployclientshow">
            <router-link :to="'/newInternetBar'">
              <el-button type="goon" style="margin-left: 20px" size="medium">
                <i class="el-icon-circle-plus"></i>&nbsp; 新建网吧
              </el-button>
            </router-link>
            <!-- <el-button style="margin-left: 20px" type="goon" size="medium"
              ><a :href="bardeployclienturlzip">部署包月客户端.zip</a>
            </el-button> -->
            <!-- <a :href="bardeployclienturlexe"><el-button style="margin-left: 20px" type="goon" size="medium"
              >部署包月通用包
            </el-button></a>
            <div style="color:#F56C6C;font-size:14px;width:600px;float:right;margin-left:20px">
              包月版安装说明：先下载包月通用包，然后下载相应网吧的配置文件，将包月通用包和配置文件放在同目录下，网吧服务器将luancher启动程序下发至客户机快捷方式即可，无需做开机启动。
            </div> -->
          </div>
        </el-col>
      </el-row>

      <!-- 内容二 -->
      <div class="table_conent">
        <template>
          <div class="table_title">网吧管理列表</div>

          <el-table class="tableBox" @sort-change="sortChange" style="height: 100%" :header-cell-style="{
          background: '#F1F6F9',
          color: '#606266',
          width: '100%',
        }" :data="tableData" border>
            <!-- agent_name -->
            <el-table-column label="ID" v-if="false">
              <template slot-scope="scope">
                <span>{{ scope.row.id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="登录账号" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.account }}</span>
              </template>
            </el-table-column>
            <el-table-column label="网吧名称" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="代理ID" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.agent_id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="代理昵称" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.agent_name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="终端机器数量" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.pc_num }}</span>
              </template>
            </el-table-column>
            <el-table-column label="在线终端数" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.bar_online_count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="付费次数" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.paid_count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="网吧状态" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.status }}</span>
              </template>
            </el-table-column>
            <el-table-column label="到期时间" width="120" align="center" sortable="custom" prop="expire_time">
              <template slot-scope="scope">
                <span>{{ dateFormate("yyyy-MM-dd hh:mm:ss", new Date(scope.row.expire_time * 1000)) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="120" align="center" sortable="custom" prop="create_time">
              <template slot-scope="scope">
                <span>{{ dateFormate("yyyy-MM-dd hh:mm:ss", new Date(scope.row.create_time * 1000)) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="客户名字" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.boss_name }}</span>
              </template>
            </el-table-column>
            <el-table-column label="客户手机" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.boss_phone }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="showMeituanId" label="美团ID" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.meituan_id }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="网吧登录账号" width align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.pswd }}</span>
                </template>
              </el-table-column> -->
            <!-- <el-table-column label="区域信息" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.county.split("-")[1] }}</span>
              </template>
            </el-table-column> -->

            <!-- <el-table-column label="备注信息" width align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.bar_remark }}</span>
              </template>
            </el-table-column> -->

            <!-- <el-table-column
              label="动态网吧"
              width
              align="center"
              v-if="agent_type == '管理员'"
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.ip_switch"
                  active-color="#13ce66"
                  active-text="是"
                  inactive-text="否"
                  @change="switchChange(scope.row)"
                  inactive-color="#eee"
                ></el-switch>
              </template>
            </el-table-column> -->

            <el-table-column label="操作" align="center" width="520">
              <template slot-scope="scope">
                <!-- agent_type -->
                <el-button v-if="agent_type == '管理员'" type="primary" plain size="mini" class="table_btn"
                @click="set_name_trigger(scope.row)">修改网吧名称</el-button>
                <el-button v-if="agent_type == '管理员'" type="primary" plain size="mini" class="table_btn"
                  @click="add_set_number(scope.row)">增减台数</el-button>
                <el-button v-if="agent_type == '管理员'" type="primary" plain size="mini" class="table_btn"
                  @click="read_gg_bar_timeclick(scope.row)">查看虚贝数据</el-button>
                <el-button v-if="agent_type == '管理员'" type="primary" plain size="mini" class="table_btn"
                  @click="reduce_gg_bar_timeclick(scope.row)">退时长</el-button>
                <el-button v-if="agent_type == '管理员'" type="warning" plain size="mini" class="table_btn"
                  @click="refund_xubei_click(scope.row)">虚贝退费</el-button>
                <el-button v-if="agent_type != '管理员'" type="primary" plain size="mini" class="table_btn"
                  @click="rechargeWay(scope.row)">充值</el-button>
                <!-- <el-button
                 v-if="agent_type != '管理员'"
                  type="primary"
                  size="mini"
                  class="table_btn"
                  @click="download_profile(scope.row)"
                  >下载配置文件</el-button
                > -->
                <!-- <el-button
                  type="primary"
                  plain
                  size="mini"
                  class="table_btn"
                  @click="editDialog(scope.row)"
                >编辑</el-button>-->
                <!-- <el-button
                  v-if="agent_type =='区域经理' || agent_type =='管理员'"
                  type="warning"
                  plain
                  size="mini"
                  class="table_btn"
                  @click="modifyAdder(scope.row)"
                >修改</el-button> -->
                <!-- <el-button
                  type="success"
                  plain
                  size="mini"
                  class="table_btn"
                  @click="internetBarDialog(scope.row)"
                  >IP绑定</el-button
                > -->

                <el-button type="danger" plain size="mini" class="table_btn"
                  @click="delinternetBar(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>

      <!-- 修改弹出框 -->
      <el-dialog :visible.sync="modifyVisible" title="修改代理区域" width="30%" center>
        <div>
          <div class="search_box">
            <el-input v-model="parme.params.name" placeholder="请输入代理区域" class="el_input_style"></el-input>
            <div class="search" @click="searchModifyAdder()">
              <img src="../../assets/images-img/echar.png" alt />
            </div>
            <div class="positionl">
              <div v-for="(item, index) in addressTitle" :key="index">
                {{ item.pid_name }}>>
                <span :class="statusClsaa == index ? 'span1' : ''" @click="districtAndCounty(item, index)">{{ item.name
                  }}</span>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer" :center="false">
          <el-button type="primary" @click="getModifyAdder()">确 定</el-button>
          <el-button @click="cancelModifyAdder()">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 充值弹窗 -->
      <el-dialog :visible.sync="recharge" title="充值" width="30%" center>
        <div class>
          <div class="visible_conent">
            <el-form ref="form" :model="form" label-width="80px" class="demo-ruleForm">
              <!-- <el-form-item label="网吧名称">
                <el-input v-model="form.name" placeholder="请输入网吧名称"></el-input>
              </el-form-item>-->
              <el-form-item label="单价(元)">
                <el-input :value="prePrice" :placeholder="bar_num" disabled></el-input>
              </el-form-item>
              <el-form-item label="终端数量">
                <el-select v-model="bar_num" placeholder="请选择">
                  <el-option v-for="item in num_options" :key="item.id" :label="item.label" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="充值时长">
                <el-select v-model="bar_month" placeholder="请选择">
                  <el-option v-for="item in month_options" :key="item.id" :label="item.label" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="支付金额" class="visible_conent_price">
                <el-input :value="price" placeholder="0" disabled></el-input>
                <span class="price">元</span>
              </el-form-item>

              <el-form-item label="支付方式">
                <el-radio-group v-model="parmasRecharge.pay_way">
                  <el-radio label="1">微信</el-radio>
                  <el-radio label="2">支付宝</el-radio>
                  <el-radio label="3">余额支付</el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- <el-form-item
                label="余额支付"
                v-if="moneyRemain != '' || moneyRemain != 0"
              >
                <el-switch
                  style="display: block; margin-top: 10px"
                  v-model="onChangStatusSwidch"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="是"
                  inactive-text="否"
                  @change="onChang"
                ></el-switch>
              </el-form-item> -->
              <div class="moneryClass">
                可用余额：
                <span>{{ moneyRemain }}</span> 元
              </div>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="rechargeDetermine()">确 定</el-button>
          <el-button @click="rechargeCancel()">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 二维码弹出层 -->
      <el-dialog :visible.sync="textQrCodeUrl" width="30%" center title="扫码充值" :before-close="disgraceful">
        <div class="qrCodeBox">
          <!-- <div class="el-dialog__headerbtn" @click="cancelDialog()">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </div> -->
          <div v-if="overtimeState == ''">
            <!-- <div class="scanQecharge">扫码充值</div> -->
            <div class="amount">订单金额：￥{{ rechargeData.amount / 100 }}</div>
            <div class="Recharge">充值时长：{{ rechargeData.time }}个月</div>
            <div ref="qrCodeUrl" id="qrcodeImg" style="display: inline-block"></div>
            <div class="foorter"></div>
            <div class="orderNumber">订单号：{{ rechargeData.ordersn }}</div>
          </div>
          <!-- <div v-else>{{overtimeState}}</div> -->
          <div v-else>
            <div class="scanQecharge">扫码充值</div>
            <div class="timeOver">{{ overtimeState }}</div>
          </div>
        </div>
      </el-dialog>
      <!-- 编辑弹窗 -->
      <!-- <el-dialog title="编辑" :visible.sync="editDialogVisible" width="30%" center>
        <el-form>
          <el-form-item label="网吧名称">
            <el-input v-model="edit.name" disabled></el-input>
          </el-form-item>
          <el-form-item label="终端包月单价(元)">
            <el-input v-model="edit.price" disabled></el-input>
          </el-form-item>
          <el-form-item label="备注信息">
            <el-input type="textarea" v-model="edit.remarks" placeholder="备注的相关信息"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editDialogCancel()">确 定</el-button>
          <el-button @click="editDialogRecharge()">取 消</el-button>
        </span>
      </el-dialog>-->


      <el-dialog title="虚贝时长信息" :visible.sync="read_gg_bar_timeshow" width="20%" center class="inter_box">
        <p>总台数：{{ gg_bar_num }}</p>
        <p>到期时间：{{ gg_bar_ex }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="read_gg_bar_timeshow = false">取 消</el-button>
          <el-button type="primary" @click="read_gg_bar_timeshow = false">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="修改网吧名称" :visible.sync="set_name_show" width="30%" center class="inter_box">
        <div style="display:flex">
          <p style="line-height:40px">名称：</p>
          <el-input v-model="set_name_form.name" style="width:60%" placeholder="输入新的网吧名称"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="set_name_submit()">确 定</el-button>
          <el-button @click="() => { this.set_name_show = false }">取 消</el-button>
        </span>
      </el-dialog>

      <el-dialog title="网吧台数增减" :visible.sync="set_number_show" width="30%" center class="inter_box">
        <div style="display:flex; margin-bottom: 20px;">
          <p style="line-height:40px;">请输入台数：</p>
          <el-input v-model="set_numberform.num" style="width:60%" placeholder="输入多少台就更新为多少台，数字"></el-input>
        </div>
        <div style="display:flex">
          <p style="line-height:40px">增加理由：</p>
          <el-input v-model="set_numberform.remark" style="width:60%" placeholder="输入增加理由"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="set_numbertrue()">确 定</el-button>
          <el-button @click="() => { this.set_number_show = false }">取 消</el-button>
        </span>
      </el-dialog>

      <el-dialog title="网吧时长扣减" :visible.sync="set_reduce_day_show" width="30%" center class="inter_box">
        <div style="display:flex; margin-bottom: 20px;">
          <p style="line-height:40px;margin-right:20px">请输入扣减的天数：</p>
          <el-input v-model="reduce_gg_bar_timefrom.day" style="width:60%" placeholder="请按实际退款的天数填写，数字"></el-input>
        </div>
        <div style="display:flex">
          <p style="line-height:40px;margin-right:75px">扣减理由：</p>
          <el-input v-model="reduce_gg_bar_timefrom.remark" style="width:60%" placeholder="输入增加理由"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="set_reducttrue()">确 定</el-button>
          <el-button @click="() => { this.set_reduce_day_show = false }">取 消</el-button>
        </span>
      </el-dialog>

      <!-- 网吧绑定 -->
      <el-dialog title="网吧绑定" :visible.sync="internetBarDialogVisible" width="30%" center class="inter_box">
        <el-form style="text-align: center; color: red">
          <el-form-item label="网吧Ip1">
            <el-input v-model="bar.ip_list1" placeholder="请输入合法的ip"></el-input>
          </el-form-item>
          <el-form-item label="网吧Ip2">
            <el-input v-model="bar.ip_list2" placeholder="请输入合法的ip"></el-input>
          </el-form-item>
          <el-form-item label="网吧Ip3">
            <el-input v-model="bar.ip_list3" placeholder="请输入合法的ip"></el-input>
          </el-form-item>
          <!-- <span v-if="disStatus.length == 3">网吧ip已满</span> -->
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="internetBarDialogCancel()">确 定</el-button>
          <el-button @click="internetBarDialogRecharge()">取 消</el-button>
        </span>
        <!-- <div
          class="footer_ip dialog-footer"
          slot="footer"
          style="
            height: 30px;
            margin-top: 20px;
            text-align: bottom;
            border-top: 1px solid #dbe4ee;
            line-height: 30px;
            color: #8aa2c3;
            padding-top: 20px;
          "
        > -->
        <!-- <span class="dialog-footer" slot="footer">已绑定IP：{{ip_list}}</span> -->
        <!-- </div> -->
      </el-dialog>

      <div class="pagetion">
        <el-pagination background layout="prev, pager, next" :total="total_count"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import * as sysApi from "../../common/sys";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      num_options: [],
      month_options: [],
      bar_num: 0,
      bar_month: 0,
      set_name_show: false,
      set_name_form: {
        id: "",
        name: "",
      },
      set_number_show: false,
      set_reduce_day_show: false,
      reduce_gg_bar_timefrom: {
        net_bar_id: 0,
        day: "",
        remark: "",
      },
      set_numberform: {
        id: "",
        num: "",
        remark: "",
      },
      read_gg_bar_timefrom: {
        net_bar_id: 0,
        day: "",
        remark: "",
      },
      read_gg_bar_timeshow: false, //时长增减弹框
      edit: {
        name: "",
        price: "",
        remarks: "",
      },
      bar: {
        ip_list1: "",
        ip_list2: "",
        ip_list3: "",
      },
      form: {
        form: "",
        resource: "",
        region: "",
      },
      // editDialogVisible: false,
      recharge: false,
      internetBarDialogVisible: false,
      options: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "试用中",
        },
        {
          value: 2,
          label: "正常",
        },
        {
          value: 5,
          label: "三天到期",
        },
        {
          value: 3,
          label: "已过期",
        }
      ],
      parme: {
        // 搜索区域
        params: {
          name: "", //
        },
      },
      duihuancount: 0,
      deductionText: "",
      netBarId: "", //选择区域的id
      addressTitle: [], //修改搜索数组
      statusClsaa: null, //修改弹出框样式
      modifyVisible: false, //修改弹出框状态
      value: "",
      searchName: "",
      tableData: [], //列表数据
      total_count: null,
      gg_bar_num: 0,
      gg_bar_ex: "",
      params: {
        bar_status: 0, // 0.全部 1.试用中 2.正常 3.已过期 4.未激活
        page: 1, // 默认一页 一页10条
        search: "", //  搜索
        ex: 4,
      },
      terminal: [
        { name: "1个月", id: 1 },
        { name: "2个月", id: 2 },
        { name: "3个月(赠送1个月)", id: 3 },
        { name: "6个月(赠送3个月)", id: 6 },
      ],
      rechargeDuration: "", //充值时长
      disabledState: true, //disabled状态
      paymentAmount: this.bar_num * this.bar_month,
      parmasRecharge: {
        money: 5,
        agent_id: "", // id
        bar_count: 0, //台数id
        id: 0, //网吧ID
        month: 1, // 月数id
        pay_way: 0, //支付方式  1是支付宝   2是微信 3 余额
        amount: 0
      },
      qrCodeRecharge: false, //二维码弹出框
      textQrCodeUrl: false,
      // 扫码充值
      rechargeData: {
        amount: "", //金额]
        ordersn: "", //订单号
        time: "", //几个月
      },
      order_sn: "",

      timer: null,
      flag: null,
      count: "",
      overtime: "",
      overtimeState: "",
      ip_list: "", //网吧列表
      net_bar_id: "", //网吧id
      list: {
        normal_count: "", // 正常
        overdue_count: "", // 已过期
        try_count: "", //  使用中
        total_month: "", //包月总数
      },
      timeStatus: null, // 定时器的时间
      timerEliminate: "",
      agent_type: "",
      switchValue: true, //动态网吧
      value2: true,
      moneyRemain: "", // 余额
      onChangStatusSwidch: false, //   开关的状态
      crityStyleEl_right_box: "",
      bardeployclientshow: true,
      bardeployclienturlzip: "",
      bardeployclienturlexe: "",
      agent_name: localStorage.getItem("agent_name"),
    };
  },

  created() {
    this.getBarNum("1");
    this.getBarNum("2");
    let type = localStorage.agent_type;
    this.agent_type = localStorage.agent_type;
    // this.moneyRemain = this.$store.state.moneyRemain; // 余额
    if (type == "管理员" || type == "子管理员") {
      this.bardeployclientshow = false;
    } else {
      this.bardeployclientshow = true;
      //this.getbarclienturl();
    }
    // if (type == "一级代理") {
    //   this.parmasRecharge.money = localStorage.getItem("agent_money")
    //     ? localStorage.getItem("agent_money")
    //     : 5;
    // } else if (type == "二级代理") {
    //   this.parmasRecharge.money = localStorage.getItem("agent_money")
    //     ? localStorage.getItem("agent_money")
    //     : 7;
    // } else if (type == "三级代理") {
    //   this.parmasRecharge.money = localStorage.getItem("agent_money")
    //     ? localStorage.getItem("agent_money")
    //     : 8;
    // }
    this.internetBarList();
    // this.barCountQuery();//顶部隐藏
    this.initMoney();

    if (this._isMobile()) {
      this.crityStyleEl_right_box = true;
    } else {
      this.crityStyleEl_right_box = false;
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  computed: {
    prePrice: function () {
      const num = this.num_options.filter(ele => ele.id == this.bar_num);
      if (num[0]) {
        return num[0].price / 100
      }

      return "";
    },
    price: function () {
      const num = this.num_options.filter(ele => ele.id == this.bar_num);
      const month = this.month_options.filter(ele => ele.id == this.bar_month);

      if (num[0] && month[0]) {
        this.rechargeData.time = month[0].price;
        return num[0].duration * num[0].price * month[0].price / 100;
      }

      return "";
    },
    // 仅当 agent_id=2 或 用户名为 gerenban 时显示美团ID列，其他用户隐藏
    showMeituanId() {
      const agentId = localStorage.getItem("agent_id");
      const accountNumber = localStorage.getItem("account_number") || "";
      return agentId == 2 || agentId === "2" || accountNumber === "gerenban";
    }
  },
  methods: {
    sortChange(column) {
      console.log(column);
      if (column.prop === "expire_time") {
        if (column.order === "descending") {
          this.params.ex = 2;
        } else {
          this.params.ex = 1;
        }
      } else {
        if (column.order === "descending") {
          this.params.ex = 4;
        } else {
          this.params.ex = 3;
        }
      }

      this.internetBarList();
    },
    dateFormate(fmt, date, isUTC) {
      date = date || new Date();
      var o = {
        "M+": (isUTC ? date.getUTCMonth() : date.getMonth()) + 1,
        "d+": isUTC ? date.getUTCDate() : date.getDate(),
        "h+": isUTC ? date.getUTCHours() : date.getHours(),
        "m+": isUTC ? date.getUTCMinutes() : date.getMinutes(),
        "s+": isUTC ? date.getUTCSeconds() : date.getSeconds(),
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          ((isUTC ? date.getUTCFullYear() : date.getFullYear()) + "").substr(
            4 - RegExp.$1.length
          )
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    //获取充值台数
    getBarNum(status) {
      this.$http4.get(this.$api.api.bar_num + status, {}).then(res => {
        if (res.data.code != 200) {
          return this.$message.error(res.data.msg);
        }
        console.log(res.data.list.length, res.data.list);
        for (let i = 0; i < res.data.list.length; i++) {
          let item = {
            id: res.data.list[i].id,
            label: res.data.list[i].product_name,
            price: res.data.list[i].product_price,
            duration: res.data.list[i].duration
          };
          if (status == "1") {
            this.num_options.push(item);
          } else {
            this.month_options.push(item);
          }
        };
        if (status == "1") {
          this.bar_num = this.num_options[0].id;
        } else {
          this.bar_month = this.month_options[0].id;
        }
      });
    },
    //确认增减时长
    read_gg_bar_time_canceltrue() {
      console.log(this.read_gg_bar_timefrom);
    },
    read_gg_bar_time_cancel() {
      this.read_gg_bar_timeshow = false;
    },
    set_name_submit() {
      sysApi.update_bar_name(this.set_name_form).then((res) => {
        if (res.code == 1) {
          this.set_name_show = false;
          this.$message.success(res.result);
          this.internetBarList();
        }
      });
    },
    set_numbertrue() {
      this.set_numberform.num = parseInt(this.set_numberform.num);
      sysApi.update_bar_num(this.set_numberform).then((res) => {
        if (res.code == 1) {
          this.set_number_show = false;
          this.$message.success(res.result);
          this.internetBarList();
        }
      });
    },

    reduce_gg_bar_timeclick(row) {
      this.set_reduce_day_show = true;
      this.reduce_gg_bar_timefrom.net_bar_id = row.id
    },

    set_reducttrue() {
      this.reduce_gg_bar_timefrom.day = parseInt(this.reduce_gg_bar_timefrom.day);
      sysApi.add_bar_time(this.reduce_gg_bar_timefrom).then((res) => {
        if (res.code == 1) {
          this.set_reduce_day_show = false;
          this.$message.success(res.result);
          this.internetBarList();
        }
      });
    },
    refund_xubei_click(row) {
      this.$confirm("确认执行虚贝退费?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          sysApi.refund_xubei({ net_bar_id: row.id }).then((res) => {
            if (res.code != 1 && res.code != 200) {
              return this.$message.error(res.result || res.msg || "虚贝退费失败");
            }
            this.$message.success(res.result || res.msg || "虚贝退费成功");
            this.internetBarList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    //管理员修改网吧名称
    set_name_trigger(row) {
      this.set_name_show = true;
      this.set_name_form = {
        id: row.id,
        name: row.name
      };
    },
    //管理员增减台数
    add_set_number(row) {
      this.set_number_show = true;
      this.set_numberform.id = row.id;
    },
    //管理员增减时长
    read_gg_bar_timeclick(row) {
      // console.log(row, 111, row.id, row.overtime)
      // this.read_gg_bar_timeshow = true;
      // // this.read_gg_bar_timefrom.day = row.overtime.split(" ")[0];
      // this.read_gg_bar_timefrom.net_bar_id = row.id;
      sysApi.read_gg_bar_time(row.id).then((res) => {
        if (res.code == 1) {
          //this.$message.success("总台数：" + res.num + " 到期时间：" + res.ex);
          this.gg_bar_num = res.num;
          this.gg_bar_ex = res.ex;
          this.read_gg_bar_timeshow = true;
        }
      });
    },

    //网吧下载链接
    getbarclienturl() {
      let account_number = "account_number=" + localStorage.agent_number;
      this.$http2
        .post(this.$api.api.bar_downloads, account_number)
        .then((res) => {
          console.log(res);
          if (res.data.code != 1) {
            return this.$message.error(res.data.result);
          }
          // this.bardeployclienturlzip = res.data.result.by_zip_url;
          this.bardeployclienturlexe = res.data.result.file_url;
        });
    },
    // 判断是pc 还是手机端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 显示余额
    initMoney() {
      this.$http.get(this.$api.api.remain_money).then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          return this.$message.error(res.data.result);
        }
        this.moneyRemain = res.data.money;
        // if (this.moneyRemain > 0) {
        //   this.duihuancount = parseInt(
        //     this.moneyRemain / prePrice
        //   );
        //   if (this.duihuancount > 1) {
        //     this.deductionText =
        //       "（可兑换" + this.duihuancount + "台终端（一个月））";
        //   } else {
        //     this.deductionText = "";
        //   }
        // } else {
        //   this.deductionText = "";
        // }
      });
    },
    //  网吧数量信息
    barCountQuery() {
      this.$http.get(this.$api.api.bar_count).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.list.normal_count = res.data.result.normal_count; // 正常
        this.list.overdue_count = res.data.result.overdue_count; // 已过期
        this.list.try_count = res.data.result.try_count; //  使用中
        this.list.total_month =
          res.data.result.normal_count +
          res.data.result.overdue_count +
          res.data.result.try_count; // 包月总数
      });
    },

    // 网吧列表
    internetBarList() {
      this.$http.post(this.$api.api.bar_list, this.params).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.total_count = res.data.total_count;
        res.data.data.forEach((element) => {
          if (element.ip_switch == 1) {
            element.ip_switch = false;
          } else {
            element.ip_switch = true;
          }
        });
        this.tableData = res.data.data;
      });
    },
    // 改变网吧状态
    switchChange(data, val) {
      if (data.ip_switch) {
        this.getSwith(data.net_bar_id, 0);
      } else {
        this.getSwith(data.net_bar_id, 1);
      }
    },
    //  改变网吧状态 方法
    getSwith(data, val) {
      let params = {
        status: val,
        net_bar_id: data,
      };
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post(this.$api.api.update_run_bar, params).then((res) => {
            if (res.data.code != 1) {
              return this.$message.error(res.data.result);
            }
            return this.$message.success(res.data.result);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    // input的值
    barCount() {
      this.TimeChange(this.rechargeDuration);
    },
    // 改变状态
    inputCanEdit() {
      this.disabledState = false;
    },
    // 弹出修改区域
    modifyAdder(data) {
      this.netBarId = data.net_bar_id;
      this.modifyVisible = true;
    },
    // 修改区域 选择样式
    districtAndCounty(data, val) {
      this.district = `${data.id}-${data.name}`;
      this.statusClsaa = val;
    },
    // 弹框框 取消按钮
    cancelModifyAdder() {
      this.modifyVisible = false;
      this.netBarId = "";
      this.district = "";
      this.parme.params.name = "";
      this.addressTitle = [];
      this.statusClsaa = null;
    },
    // 确定修改
    getModifyAdder() {
      if (!this.district) {
        return this.$message.error("请选择需要修改的区域");
      }
      let parme = { district: this.district, net_bar_id: this.netBarId };
      this.$http.post(this.$api.api.update_bar_district, parme).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.modifyVisible = false;
        this.netBarId = "";
        this.district = "";
        this.parme.params.name = "";
        this.addressTitle = [];
        this.statusClsaa = null;
        this.internetBarList();
        this.$message.error(res.data.result);
      });
    },
    // 修改区域的搜索
    searchModifyAdder() {
      if (!this.parme.params.name) {
        return this.$message.error("请输入代理区域");
      }
      this.$http.get(this.$api.api.search_district, this.parme).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        } else if (res.data.result.length == 0) {
          this.$message.error("暂无代理区域！");
        } else {
          this.addressTitle = res.data.result;
        }
      });
    },

    twoStatus() {
      this.$http4
        .post(this.$api.api.create_order, {
          ...this.parmasRecharge,
          pay_way: this.parmasRecharge.pay_way / 1,
        })
        .then((res) => {
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          } else {
            this.recharge = false;
            this.textQrCodeUrl = true;
            this.$nextTick(function () {
              this.rechargeData.amount = res.data.amount;
              this.rechargeData.ordersn = res.data.order_sn;
              //this.rechargeData.time = res.data.data.time;
              this.$store.commit("orderState", res.data.order_sn);
              this.order_sn = res.data.order_sn;
              this.$refs.qrCodeUrl.innerHTML = "";

              this.creatQrCode({
                qrcode: res.data.ret
              });

              let count = 0;
              let countTime = 1500;
              this.timerEliminate = setInterval(() => {
                count++;
                if (count == 10) {
                  countTime = 3000;
                }
                if (count == 50) {
                  countTime = 3500;
                }
                if (count == 100) {
                  countTime = 4000;
                }
                if (count == 180) {
                  clearInterval(this.timerEliminate);
                }
                this.stateOrder();
              }, countTime);
            });
            this.initMoney();
            return this.$message.success(res.data.result);
          }
        });
    },
    // 如果用余额的话 就调这个接口
    orderRemain(type) {
      // const data = {
      //   ...this.parmasRecharge,
      //   pay_way: 3,
      // };

      if (type == 1) {
        // debugger;
        // this.parmasRecharge.use_remain_money = this.paymentAmount;
        // data.use_remain_money = this.paymentAmount;

        // this.$http3.post(this.$api.api.remain_order, data).then((res) => {
        //   console.log(res);
        //   if (res.data.code != 1) {
        //     return this.$message.success(res.data.result);
        //   }
        //   this.recharge = false;
        //   this.initMoney();
        //   this.internetBarList();
        //   return this.$message.success(res.data.result);
        // });
        this.$http4
          .post(this.$api.api.create_order, {
            ...this.parmasRecharge,
            pay_way: this.parmasRecharge.pay_way / 1,
          })
          .then((res) => {
            if (res.data.code != 200) {
              return this.$message.error(res.data.msg);
            } else {
              this.initMoney();
              this.recharge = false;
              return this.$message.success("支付成功");
            }
          })
      } else {
        this.$http3.post(this.$api.api.remain_order, data).then((res) => {
          console.log(res);
          if (res.data.code != 1) {
            return this.$message.error(res.data.result);
          } else {
            this.recharge = false;
            this.textQrCodeUrl = true;
            this.$nextTick(function () {
              this.rechargeData.amount = res.data.data.amount;
              this.rechargeData.ordersn = res.data.data.ordersn;
              this.rechargeData.time = res.data.data.time;
              this.$store.commit("orderState", res.data.data.ordersn);
              this.parmas.order_sn = res.data.data.ordersn;
              this.$refs.qrCodeUrl.innerHTML = "";
              this.creatQrCode(res.data.data);
              let count = 0;
              let countTime = 1500;
              this.timerEliminate = setInterval(() => {
                count++;
                if (count == 10) {
                  countTime = 3000;
                }
                if (count == 50) {
                  countTime = 3500;
                }
                if (count == 100) {
                  countTime = 4000;
                }
                if (count == 180) {
                  clearInterval(this.timerEliminate);
                }
                this.stateOrder();
              }, countTime);
            });
            this.initMoney();
            return this.$message.success(res.data.result);
          }
        });
      }
    },
    // 充值确定两种情况  1是  开始余额支付      2是开启余额支付余额不足
    rechargeDetermine() {
      if (this.bar_month == "请选择") {
        return this.$message.error("请选择时长!");
      }
      if (this.bar_num == "请选择") {
        return this.$message.error("请选择台数!");
      }
      this.parmasRecharge.bar_count = this.bar_num;
      this.parmasRecharge.month = this.bar_month;
      this.parmasRecharge.amount = this.price * 100

      if (this.parmasRecharge.pay_way == 3) {
        if (this.moneyRemain * 100 >= this.parmasRecharge.amount) {
          this.orderRemain(1); // 余额支付
        } else {
          return this.$message.success("余额不足，请更换其它支付方式");
          // this.parmasRecharge.use_remain_money = this.moneyRemain;
          // this.parmasRecharge.use_remain_money =
          //   this.duihuancount * localStorage.getItem("agent_money");
          // this.orderRemain(2); // 开启余额支付余额不足
        }
      } else {
        this.twoStatus(); // 不开启余额支付
      }
    },

    onChang(status) {
      this.onChangStatusSwidch = status;
    },

    // 生成二维码
    creatQrCode(val) {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: val.qrcode, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    //  订单状态
    stateOrder() {
      this.$http4.get(this.$api.api.status + "/" + this.order_sn).then((res) => {
        if (res.data.code == 200 && (res.data.msg == "2" || res.data.msg == "3")) {
          clearInterval(this.timerEliminate);
          this.textQrCodeUrl = false;
          this.internetBarList();
          if (res.data.msg == 2) {
            return this.$message.success("支付成功");
          }
          return this.$message.success("订单已超时");
        }
      });
    },

    disgraceful() {
      this.cancelDialog();
    },
    // 关闭充值
    cancelDialog() {
      this.textQrCodeUrl = false;
      clearInterval(this.timerEliminate);
      console.log(1111111111111);
    },

    // 分页
    handleCurrentChange(val) {
      this.params.page = val;
      this.internetBarList();
    },
    // 搜索
    searchQuery() {
      this.params.search = this.searchName;
      this.internetBarList();
    },
    // 更新网吧状态
    selectState(event) {
      console.log(event);
      this.params.bar_status = event;
      this.internetBarList();
    },
    //下载配置文件
    download_profile(row) {
      // let formdata = new FormData();
      // formdata.append('account_number',localStorage.agent_number);
      // formdata.append('net_bar_id',row.net_bar_id);
      // formdata.append("net_bar_name",row.Name);
      let pa =
        "?account_number=" +
        localStorage.agent_number +
        "&net_bar_id=" +
        row.net_bar_id +
        "&net_bar_name=" +
        row.Name;
      sysApi.downloadby_profile(pa).then((res) => {
        window.location.href =
          "https://new-file.yebaojiasu.com/api/v1/new_file/bar_config?account_number=" +
          localStorage.agent_number +
          "&net_bar_id=" +
          row.net_bar_id +
          "&net_bar_name=" +
          row.Name;
      });
    },
    // 点击充值
    rechargeWay(value) {
      this.parmasRecharge.id = value.id;
      this.parmasRecharge.month = 1;
      this.parmasRecharge.pay_way = "1";
      this.recharge = true;
      this.rechargeDuration = "请选择";
    },
    // 充值取 消
    rechargeCancel() {
      // this.parmasRecharge.bar_count = 20;
      this.parmasRecharge.cyberbar_id = null;
      this.parmasRecharge.month = 1;
      (this.parmasRecharge.pay_way = "0"), (this.recharge = false);
      this.rechargeDuration = "请选择";
    },

    internetBarDialog(val) {
      console.log(val);

      this.ip_list = val.ip_list;
      this.net_bar_id = val.net_bar_id;
      let disStatus = val.ip_list.split(",");

      this.bar.ip_list1 = disStatus[0];
      this.bar.ip_list2 = disStatus[1];
      this.bar.ip_list3 = disStatus[2];
      this.internetBarDialogVisible = true;
    },
    // 网吧确定
    internetBarDialogCancel() {
      let { ip_list1, ip_list2, ip_list3 } = { ...this.bar };
      this.addBar(ip_list1, ip_list2, ip_list3);

      // 后端返回3个地址的时候
      // if (this.disStatus.length == 3) {
      //   return this.$message.error("ip地址已满");
      // }

      // 后端返回2个地址的时候
      // if (this.disStatus.length == 2) {
      //   if (ip_list3 == "") {
      //     return this.$message.error("请输入ip地址");
      //   } else {
      //     if (ip_list3.length > 7 && ip_list3.length < 20) {
      //       this.addBar(ip_list3);
      //     } else {
      //       return this.$message.error("请输入合法的ip地址");
      //     }
      //   }
      // }
      // 后端返回1个地址的时候
      // if (this.disStatus.length == 1) {
      //   if (ip_list2 != "" || ip_list3 != "") {
      //     if (ip_list3 == ip_list2) {
      //       return this.$message.error("ip地址不能相同");
      //     }
      //     if (
      //       (ip_list2.length > 10 && ip_list2.length < 20) ||
      //       (ip_list3.length > 10 && ip_list3.length < 20)
      //     ) {
      //       this.addBar(ip_list2, ip_list3);
      //     } else {
      //       return this.$message.error("请输入合法的ip地址");
      //     }
      //   } else {
      //     return this.$message.error("请输入ip地址");
      //   }
      // }

      // 后端返回0个地址的时候
      // if (this.disStatus.length == 0) {
      //   if (ip_list1 != "" || ip_list2 != "" || ip_list3 != "") {
      //     if (ip_list3 == ip_list2) {
      //       return this.$message.error("ip地址不能相同");
      //     }
      //     if (ip_list3 == ip_list1) {
      //       return this.$message.error("ip地址不能相同");
      //     }
      //     if (ip_list2 == ip_list1) {
      //       return this.$message.error("ip地址不能相同");
      //     }
      //     if (
      //       (ip_list1.length > 10 && ip_list1.length < 20) ||
      //       (ip_list2.length > 10 && ip_list2.length < 20) ||
      //       (ip_list3.length > 10 && ip_list3.length < 20)
      //     ) {
      //       this.addBar(ip_list1, ip_list2, ip_list3);
      //     } else {
      //       return this.$message.error("请输入合法的ip地址");
      //     }
      //   } else {
      //     return this.$message.error("请输入ip地址");
      //   }
      // }
    },

    // 公众方法添加ipp地址
    addBar(ip_list1 = "", ip_list2 = "", ip_list3 = "") {
      console.log(ip_list1, ip_list2, ip_list3);
      var ip_list_add = "";
      if (ip_list1.length >= 7) {
        ip_list_add += "," + ip_list1;
      }
      console.log(ip_list2, 11111);
      if (ip_list2.length >= 7) {
        ip_list_add += "," + ip_list2;
      }
      if (ip_list3.length >= 7) {
        ip_list_add += "," + ip_list3;
      }
      let aggregateIp = ip_list_add.replace(",", "");
      let params_ip_list = {
        ip_list: aggregateIp,
        net_bar_id: this.net_bar_id,
      };
      this.$http.post(this.$api.api.add_bar_ip, params_ip_list).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.internetBarList();
        this.internetBarDialogVisible = false;
        this.bar.ip_list1 = "";
        this.bar.ip_list2 = "";
        this.bar.ip_list3 = "";
        return this.$message.success(res.data.result);
      });
    },

    // 网吧取消
    internetBarDialogRecharge() {
      this.internetBarDialogVisible = false;
      this.bar.ip_list1 = "";
      this.bar.ip_list2 = "";
      this.bar.ip_list3 = "";
    },
    delinternetBar(net_bar_id) {
      let delBar = {
        params: {
          net_bar_id: net_bar_id,
        },
      };
      this.$confirm("此操作将永久删除该网吧, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.get(this.$api.api.delete_bar, delBar).then((res) => {
            if (res.data.code != 1) {
              return this.$message.error(res.data.result);
            }
            this.internetBarList();
            return this.$message.success(res.data.result);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content_box {
  .multiple {
    display: flex;

    .model_navigation {
      width: 240px;
      height: 79px;
      border: 1px solid #ebeef5;
      text-align: center;
      justify-content: center;
      align-items: center;
      display: flex;
      font-size: 14px;

      img {
        width: 38px;
        height: 38px;
      }

      .span1 {
        margin-right: 5px;
        margin-left: 5px;
      }

      .span2 {
        sup {
          font-size: 22px;
        }
      }
    }

    .model_navigation {
      border-left: 0;
    }

    .model_navigation:first-child {
      border-left: 1px solid #f1f6f9;
    }
  }

  .el_right_box {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    // height: 80px;

    // background: red;
    .status {
      padding-right: 10px;
      padding-left: 10px;
      font-size: 12px;
    }

    .el_input_style {
      width: 200px;
    }

    .each_txt {

      // position: relative;
      .search_txt {
        padding: 0 10px;
        font-size: 12px;
      }
    }
  }

  .el-col-12 {
    width: 100%;
  }

  .el-dialog__body {
    padding-top: 0 !important;
    height: 468px !important;
  }

  .el_right_box1 {
    display: flex;

    // justify-content: center;
    // align-items: center;
    // height: 80px;
    // margin-top: 100px;
    // background: red;
    .status {
      padding-right: 10px;
      padding-left: 10px;
      font-size: 12px;
    }

    .el_input_style {
      width: 200px;
    }

    .each_txt {

      // position: relative;
      .search_txt {
        padding: 0 10px;
        font-size: 12px;
      }
    }
  }

  .table_conent {
    padding-top: 20px;

    .table_title {
      border: 1px solid #ebeef5;
      border-bottom: 0px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #f1f6f9;
    }

    .table_btn {
      // width: 80px !important;
    }
  }
}

.el-table {
  margin-top: 0px !important;
}

.tableBox {
  th {
    height: 30px;
    line-height: 30px;
  }
}

.tableBox {
  td {
    height: 30px;
    line-height: 30px;
  }
}

.pagetion {
  // display: flex;
  margin-bottom: 30px;
  text-align: right;
}

.el-pagination {
  padding: 0 !important;
}

.visible_conent {
  .visible_conent_price {
    position: relative;

    .price {
      text-align: center;
      display: inline-block;
      width: 100px;
      height: 38px;
      background: #f8fbff;
      border-left: 1px solid #dcdfe6;
      position: absolute;
      top: 1px;
      right: 4px;
    }
  }

  .visible_conent_minimum {
    position: relative;

    .minimum {
      text-align: center;
      display: inline-block;
      width: 100px;
      height: 38px;
      background: #f8fbff;
      border-left: 1px solid #dcdfe6;
      position: absolute;
      top: 1px;
      right: 4px;
    }

    .el_but {
      width: 100px;
      height: 38px;
      text-align: center;
      // display: inline-block;
      // width: 100px;
      // height: 38px;
      // background: #f8fbff;
      // border-left: 1px solid #dcdfe6;
      position: absolute;
      top: 1px;
      right: 1px;
    }
  }
}

.qrCodeBox {
  margin: 0 auto;
  background: #fff;
  width: 400px;
  height: 400px;
  text-align: center;

  .scanQecharge {
    font-size: 20px;
    font-weight: bold;
  }

  .amount {
    padding-top: 15px;
    color: #ff0000;
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 10px;
  }

  .Recharge {
    color: #7e7e7e;
    font-size: 14px;
    padding-bottom: 10px;
  }

  #qrcodeImg {
    border: 1px solid #eee;
    padding: 20px;
  }

  .foorter {
    border-bottom: 2px solid #dbe4ee;
    margin: 20px;
  }

  .orderNumber {
    color: #8aa2c3;
    font-size: 14px;
  }
}

.timeOver {
  color: #ff0000;
  font-size: 20px;
  font-weight: bold;
  margin: 160px auto;
}

.search_box {
  display: inline-block;
  position: relative;
  width: 280px;

  .search {
    position: absolute;
    top: 5px;
    right: 8px;
    width: 53px;
    height: 30px;
    background: #409eff;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 6px;
    cursor: pointer;

    img {
      width: 15px;
      height: 18px;
    }
  }

  .positionl {
    margin-top: 30px;

    div {
      margin-top: 30px;

      span {
        margin-left: 30px;
        display: inline-block;
        border: 1px solid #fff;
        padding: 3px;
        font-size: 12px;
        cursor: pointer;
      }

      .span1 {
        margin-left: 30px;
        display: inline-block;
        border: 1px solid #409eff;
        color: #409eff;
        padding: 3px;
        font-size: 12px;
        cursor: pointer;
      }

      span:hover {
        margin-left: 30px;
        display: inline-block;
        border: 1px solid #409eff;
        color: #409eff;
        padding: 3px;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
}

.dialog-footer-right {
  text-align: right !important;
}

.moneryClass {
  margin-left: 10px;

  span {
    color: red;
  }
}

.el-form-item {
  margin-bottom: 20px !important;
}

.el-input__inner {
  width: 200px !important;
}
</style>
